import { jsonHeaders } from '#lib/helpers/fetch.js';
import { useAuthMutation } from '#lib/hooks/use-mutation.js';

async function publish(query = '', city = '', country = '', stars = '', language = '', lek = '', authHeaders) {
    const response = await fetch(`${HB_API_URL}/h/search?query=${query.toLowerCase()}&city=${city.toLowerCase()}&country=${country.toLowerCase()}&stars=${stars}${lek ? `&lek=${lek}` : ''}&language=${language}`, {
        method: 'GET',
        headers: { ...jsonHeaders, authorization: `${HB_SECRET_KEY}` },
    });
    return await response.json();
}
export function useHotelbedsSearch(options) {
    return useAuthMutation({
        mutationFn: (data, authHeaders) => publish(data.query, data.city, data.country, data.stars, data.language, data.lek, authHeaders),
        ...options
    });
}